<h1 mat-dialog-title>{{data.title}}</h1>
<section>
    <section mat-dialog-content>
        <p class="break-lines">{{data.description}}</p>
    </section>
    <section mat-dialog-actions fxLayout="row" fxLayoutAlign="center center">
        <button mat-raised-button color="accent" [mat-dialog-close]="true">{{data.ok_action_name}}</button>
    </section>
</section>